var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 14.25L14.4797 12.4371L10.6164 8.57375L7.44975 11.7404L1.5835 5.86625L2.69975 4.75L7.44975 9.5L10.6164 6.33333L15.6039 11.3129L17.4168 9.5V14.25H12.6668Z",
    fill: "#F93C65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownTrend);
export default __webpack_public_path__ + "static/media/DownTrend.a1edf289121ce04b8f4f51712f828c19.svg";
export { ForwardRef as ReactComponent };